import ValueAdjustment from './ValueAdjustmentList.vue';

export default ValueAdjustment;
